import React, { useEffect, useRef, useState } from "react"
import {
  header,
  burgerMenu,
  burgerMenuOpen,
  logoSite,
  logoSiteImg,
  burgerMenuTitle,
  skipLink,
} from "./header.module.scss"
import ImageFromDrupal from "../../Image/image-from-drupal"
import { useBuildData } from "../../../hooks/use-build-data"
import { BurgerSpan, LogoSite } from "./header-styled"
import AniLink from "gatsby-plugin-transition-link/AniLink"
import MainMenu from "./MainMenu/main-menu"
import { useHeader } from "./header-query"
import Icon from "../../Icon/icon"
import EditButton from "../../EditButton/edit-button"

//-----------------------Parent Component---------------------------//

const Header = () => {
  const buildColors = useBuildData().theme_settings.palette
  const buildInfos = useBuildData().site_settings
  const data = useHeader()
  const [openBurger, setOpenBurger] = useState(false)
  const menuData = data.allMenuLinkContentMenuLinkContent.edges
  const burgerMenuRef = useRef()

  useEffect(() => {
    if (typeof document !== `undefined`) {
      const container = document.getElementById("menuItems")
      const handleFocusOut = (event) => {
        const isInside =
          container.contains(event.relatedTarget) ||
          burgerMenuRef.current === event.relatedTarget
        if (!isInside && openBurger) {
          burgerMenuRef.current.focus()
        }
      }

      document.addEventListener("focusout", handleFocusOut, true)
      return () => {
        document.removeEventListener("focusout", handleFocusOut, true)
      }
    }
  }, [openBurger])
  if (typeof document !== `undefined`) {
    document.addEventListener("keyup", (event) => {
      if (event.key === "Escape") {
        setOpenBurger(false)
      }
    })
  }
  return (
    <>
      <a
        className={skipLink}
        href={"#top"}
        aria-label={"Lien d'accès rapide au menu"}
        tabIndex="0"
      >
        {"Lien d'accès rapide au menu"}
      </a>
      <a
        className={skipLink}
        href={"#main"}
        aria-label={"Lien d'accès rapide au contenu principal"}
        tabIndex="0"
      >
        {"Lien d'accès rapide au contenu principal"}
      </a>
      <a
        className={skipLink}
        href={"#search-input"}
        aria-label={"Lien d'accès rapide à la recherche"}
        tabIndex="0"
      >
        {"Lien d'accès rapide à la recherche"}
      </a>
      <a
        className={skipLink}
        href={"#footer"}
        aria-label={"Lien d'accès rapide au pied de page"}
        tabIndex="0"
      >
        {"Lien d'accès rapide au pied de page"}
      </a>
      <header className={header} role="banner">
        <LogoSite className={logoSite}>
          <EditButton link={"/admin/site-configuration"} />
          <AniLink
            aria-label={buildInfos.website_name + " - Accueil"}
            paintDrip
            hex={buildColors.a_color_gradients.a_dark}
            to="/"
          >
            {buildInfos.website_logo.fid === null ? (
              <Icon size={48} icon="home" />
            ) : (
              <ImageFromDrupal
                className={logoSiteImg}
                alt={"Logo " + buildInfos.website_name}
                drupal_fid={buildInfos.website_logo.fid}
              />
            )}
          </AniLink>
        </LogoSite>

        <nav
          ref={burgerMenuRef}
          title={!openBurger ? "Ouverture du menu" : "Fermeture du menu"}
          aria-expanded={openBurger}
          tabIndex={0}
          role="button"
          className={!openBurger ? burgerMenu : burgerMenuOpen}
          onClick={() => setOpenBurger(!openBurger)}
          onKeyDown={(event) => {
            if (event.key === "Enter") {
              setOpenBurger(!openBurger)
            }
          }}
        >
          <BurgerSpan></BurgerSpan>
          <BurgerSpan></BurgerSpan>
          <BurgerSpan></BurgerSpan>
          <BurgerSpan></BurgerSpan>
          <p className={burgerMenuTitle}>Menu</p>
        </nav>
        <MainMenu mainMenuData={menuData} />
      </header>
    </>
  )
}

//-----------------------Parent Component---------------------------//

export default Header
